
import React from 'react';
import CampaignRecipientInfoComponent, { CompaignRecipientInfoComponent } from './campaign-recipient-info.component';
import CampaignBudgetInfoComponent from './campaign-budget-info.component';
import CampaignInfoComponent from './campaign-info.component';
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../common/components/form/form.module';
import TabContainer from '../../../../common/components/tab/containers/tab.containers';
import CampaignTemplatesComponent from './campaing-templates.component';
import ListMarketingPlans from './plans';
import Table from '../../../../common/components/table';

const EMAIL_TEMPLATE_TYPE = 20

export const CampaignEmailInfoComponent = ({
  agents,
  paginationData,
  setPageData,
  rowData,
  columnDefs,
  onPlanIdChange,
  choosenTemplate,
  choosenCampaign,
  campaignFrequency,
  customerTags,
  choosenEmailPlan,
  emailBudget,
  emailNotes,
  setSelectedTemplate,
  selectedTemplate,
  handlePlanSelect,
  handleInnerFormChange,
  vendorRowData,
  VendorpaginationData,
  vendorColumnDefs
}: any) => {
console.log(rowData,'rowData')
console.log(vendorRowData,'vendorRowData')
  // const handlePlanSelect = (data: any) => {
  //   // choosenCampaign.EmailPlanId
  //   // handleInnerFormChange(choosenCampaign.EmailPlanId, 'EmailPlanId');
  //   console.log('Selected plan', data)
  //   selectedPlan = data;
  // }
  const tabItems=[
    {
        id:1,
        title:'Recipient',
        component:   <CompaignRecipientInfoComponent
        choosenEmailPlan={choosenCampaign}
        handleInnerFormChange={handleInnerFormChange}
        customerTags={customerTags}
      />,
    isVisible:true ,
    },
  ]
  console.log(choosenCampaign,'choosenCampanin email')
  return (
    <>
      <AccordionContainer
        child={
        <div className='grid grid-cols-2 gap-4 w-full'>
  <InputContainer
  isDisabled
    label="Name"
    labelField="Name"
    onValueChange={(event: any, newValue: any) => {
      handleInnerFormChange(event.target.value, 'Name');
    }}
    type="text"
    value={choosenCampaign?.Name}
  />

  <InputContainer
  isDisabled
    label="Campaign Frequency"
    labelField="Text"
    list={campaignFrequency}
    onValueChange={(event: any) => {
      handleInnerFormChange(event.target.value, 'FrequencyId');
    }}
    optionName='Choose Campaign Frequency'
    type="select"
    value={choosenCampaign?.FrequencyId}
    valueField="Value"
  />

  <InputContainer
  isDisabled
    isDateTimePicker
    label="Start Date"
    name="StartDate"
    onValueChange={(event: any) => {
      handleInnerFormChange(event.target.value, 'StartDate');
    }}
    type="date"
    value={choosenCampaign?.StartDate}
  />

  <InputContainer
  isDisabled
    isDateTimePicker
    label="End Date"
    name="EndDate"
    onValueChange={(event: any) => {
      handleInnerFormChange(event.target.value, 'EndDate');
    }}
    type="date"
    value={choosenCampaign?.EndDate}
  />
</div>

        }
        expandedPanel="Basic Info"
        headerTitle="Basic Info"
      />

<AccordionContainer
        child={
          <TabContainer tabItems={tabItems} />
        }
        expandedPanel="Email Campaign Receipient Info"
        headerTitle="Email Campaign Receipient Info"
      />
    <AccordionContainer
        child={
          <ListMarketingPlans 
            choosenCampaign={choosenCampaign}
            handleInnerFormChange={handleInnerFormChange} 
            campaignFrequency={campaignFrequency}
            customerTags={customerTags}
            emailNotes={emailNotes}
            emailBudget={emailBudget}
            choosenEmailPlan={choosenEmailPlan}   
            onPlanIdChange={onPlanIdChange}
            setSelectedTemplate={setSelectedTemplate}
            selectedTemplate={selectedTemplate}   
            choosenTemplate={choosenTemplate}
            onSelect={handlePlanSelect}
          />
          
        }
        expandedPanel="Plans"
        headerTitle="Select a Plan"
      />

{/* <AccordionContainer
        child={
          <div className='w-1/2 grid grid-cols-1'>
               <InputContainer
                label="DSAP Mapping"
                labelField="AssociatedParnterAccountName"
                list={agents}
                onValueChange={(event: any) => {
                  handleInnerFormChange(event.target.value, 'DSAPId');
                }}
                optionName='Choose DSAP Agent'
                type="select"
                value={choosenCampaign?.DSAPId}
                valueField="AssociatedPartnerAccountMappingPId"
              />
           </div>
        }
        expandedPanel="DSAP Mapping Info"
        headerTitle="DSAP Mapping Info"
      />
       <AccordionContainer
        child={
          <Table
          columnData={columnDefs}
          rowData={rowData}
          headingName="Associated mapped Product Info"
          setPageData={setPageData}
          paginationData={paginationData}
          />
          
        }
        expandedPanel="Associated mapped Product Info"
        headerTitle="Associated mapped Product Info "
      />
  <AccordionContainer
        child={
          <Table
          columnData={vendorColumnDefs}
          rowData={vendorRowData}
          headingName="Associated mapped Vendor Info"
          setPageData={setPageData}
          paginationData={VendorpaginationData}
          />
          
        }
        expandedPanel="Associated mapped Vendor Info"
        headerTitle="Associated mapped Vendor Info "
      /> */}
      {/* <AccordionContainer
        child={
          <CampaignTemplatesComponent
            templateType={EMAIL_TEMPLATE_TYPE}
            setSelectedTemplate={setSelectedTemplate}
            selectedTemplate={selectedTemplate}
            choosenTemplate={choosenTemplate}
          />
        }
        expandedPanel="Templates"
        headerTitle="Select a Template"
      /> */}
    </>
  );
};
export default CampaignEmailInfoComponent;
